import { statinModerateIntensityActivity } from './definitions/activities/statinModerateIntensity';
import { ckdOngoingMeasurements } from './definitions/ckdOngoingMeasurements';
import { ckdStageMonitoring } from './definitions/ckdStageMonitoring';
import { hyperlipidemiaMonitoring } from './definitions/hyperlipidemiaMonitoring';
import { hypertensionMonitoring } from './definitions/hypertensionMonitoring';
import { masldOngoingMeasurements } from './definitions/masldOngoingMeasurements';
import { obesityOngoingMeasurements } from './definitions/obesityOngoingMeasurements';
import { preventionScreening } from './definitions/preventionScreening';
import { asthmaOngoingMeasurements, copdOngoingMeasurements } from './definitions/respiratoryOngoingMeasurements';
import {
  hyperthyroidismOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
} from './definitions/thyroidOngoingMeasurements';
import { t2dmOngoingMeasurements } from './definitions/t2dmOngoingMeasurements';
import { t2dmRoutineMonitoring } from './definitions/t2dmRoutineMonitoring';
import {
  aceInhibitorsValueSet,
  angiotensinReceptorBlockersValueSet,
  classIiiAntiarrhythmicsValueSet,
  csDmardsValueSet,
  factorXaInhibitorsValueSet,
  insulinsValueSet,
  mineralocorticoidAntagonistsValueSet,
  statinsValueSet,
  sulfonylureasValueSet,
  urateLoweringTherapyValueSet,
  vitaminKAntagonistsValueSet,
} from './valueSets/rxNormDrugClasses';

/** The clinical protocols `@liza/medplum-config` deploys. */
export const planDefinitions = {
  t2dmRoutineMonitoring,
  t2dmOngoingMeasurements,
  ckdOngoingMeasurements,
  obesityOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
  hyperthyroidismOngoingMeasurements,
  copdOngoingMeasurements,
  asthmaOngoingMeasurements,
  masldOngoingMeasurements,
  ckdStageMonitoring,
  hypertensionMonitoring,
  hyperlipidemiaMonitoring,
  preventionScreening,
};

/** What the protocols' suggestion actions propose, referenced by `definitionCanonical` and deployed alongside them. */
export const protocolActivityDefinitions = {
  statinModerateIntensityActivity,
};

/** The terminology the protocols reference, deployed alongside them. */
export const protocolValueSets = {
  aceInhibitorsValueSet,
  angiotensinReceptorBlockersValueSet,
  classIiiAntiarrhythmicsValueSet,
  csDmardsValueSet,
  factorXaInhibitorsValueSet,
  insulinsValueSet,
  mineralocorticoidAntagonistsValueSet,
  statinsValueSet,
  sulfonylureasValueSet,
  urateLoweringTherapyValueSet,
  vitaminKAntagonistsValueSet,
};
